var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LogoWithMono from '../../../LogoWithMono';
const LogoTrenitaliaReg = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 60, height: 18, viewBox: "0 0 60 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M35.4087 0L35.8272 0.112512C38.1183 0.797734 39.3494 2.57938 39.3494 5.14087C39.3494 7.63132 37.6802 9.28352 34.6998 10.107C35.1951 10.778 35.6161 11.5709 35.9628 12.4768C36.6255 14.208 37.2623 15.6894 37.8711 16.9189C37.9442 17.0664 38.2801 17.8597 38.3523 18H35.3195C35.3267 18 35.3264 17.9946 35.3225 17.9865L35.2839 17.927C34.6668 16.6594 34.0323 15.173 33.3789 13.4659C32.7491 11.8208 31.895 10.84 30.8202 10.4181L30.8505 10.431L26.5306 10.4322L25.0316 17.9715H22.2023L23.7133 10.4322H21L21.5783 7.66537H24.2444L25.1835 2.766L22.5837 2.76678L23.1207 0H35.4087ZM35.0466 2.76678H28.0021L27.0617 7.66537H32.97C35.5494 7.19609 36.5826 6.35002 36.5826 5.14087C36.5826 3.78099 36.1258 3.09183 35.0466 2.76678Z", fill: "black" }))),
        alt: 'Trenitalia Reg',
    };
    return React.createElement(LogoWithMono, Object.assign({}, commonProps, { fixedHeight: 18, source: source }));
};
export default LogoTrenitaliaReg;
//# sourceMappingURL=index.js.map